/* eslint-disable no-undef */
import { datadogRum } from '@datadog/browser-rum'
import { datadogLogs } from '@datadog/browser-logs'
import { initEmbeddingTelemetry } from './telemetry/embedding'

// Sentry
import * as Sentry from '@sentry/react'

if (USE_RUM === 'true') {
  datadogRum.init({
    applicationId: RUM_APPLICATION_ID,
    clientToken: RUM_CLIENT_TOKEN,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: true,
    defaultPrivacyLevel: 'mask-user-input',
    actionNameAttribute: 'data-testid',
    service: 'lender-frontend',
    env: DEPLOYMENT_ENVIRONMENT,
    version: RELEASE_VERSION,
  })
  initEmbeddingTelemetry()
}

datadogLogs.init({
  service: 'lender-frontend',
  env: DEPLOYMENT_ENVIRONMENT,
  version: RELEASE_VERSION,
  clientToken: RUM_CLIENT_TOKEN,
  forwardReports: [],
  forwardConsoleLogs: [],
  forwardErrorsToLogs: false,
  sessionSampleRate: 100,
  telemetrySampleRate: 100,
})

datadogLogs.logger.setHandler(DD_LOGS_HANDLER || 'console')
datadogLogs.logger.setLevel(DD_LOGS_LEVEL || 'error')

if (USE_SENTRY === 'true') {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: DEPLOYMENT_ENVIRONMENT,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0,
    ignoreErrors: [
      'ResizeObserver loop completed with undelivered notifications',
    ],
  })
}
